module.exports = __webpack_public_path__ + "img/black00_128.ac2dfd6d.png";